<div class="flex items-center justify-center m-3 w-full">
  <button
    (click)="onReportProblem()"
    class="cursor-pointer w-full sm:w-auto bg-red-500 hover:bg-red-600 text-white text-sm sm:text-base px-4 py-2 sm:px-6 sm:py-3 rounded-md transition-colors"
  >
    Reportar Problema
  </button>
</div>

<modal-send-claim #modalSendClaim (loadEvent)="loadEvent()"></modal-send-claim>
